/*========================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "jquery",
    "underscore",
    "utils/dom",
    "utils/aria/role",
    "utils/aria/accordion",
    "utils/aria/toolbar",
    "utils/aria/dialog",
    "utils/aria/tooltip",
    "utils/keys"
  ], function (
    $,
    _,
    dom,
    Role,
    tablistHandler,
    toolbarHandler,
    dialogHandler,
    TooltipRole,
    keys
  ) {
  var LEFT = 37;
  var UP = 38;
  var RIGHT = 39;
  var DOWN = 40;
  var TAB = 9;
  var HOME = 36;
  var END = 35;

  var Tree = function () {
    this.initialize.apply(this, arguments);
  };

  _.extend(Tree.prototype, {

      initialize: function (options) {
        this.$el = $(options.el);
        this.$el.attr("role", "tree");
        this.$el.attr("tabindex", "0");;
        this.$el.on("keyup.mb-accessibility", _.bind(this.keyUp, this));
        this.$el.on("focusin.mb-accessibility", _.bind(this.focus, this));
        this.$el.on("focusout.mb-accessibility", _.bind(this.focusout, this));
        this.$el.on("changeselect.mb-select-target", _.bind(this.changeselect, this));
      },

      treeitems: function () {
        var treeitems = this.$el.find("[role=treeitem]");
        return treeitems;
      },

      setTabable: function (el) {
        var els = this.treeitems().not(el);
        els.attr("tabindex", "-1");
        this.$el.find(".mb-select-target").attr("tabindex", "-1");
        $(el).attr("tabindex", "0");
      },

      selected: function () {
        var focused = this.$el.find(":focus");
        var selected = focused.is("[role=treeitem]") ? focused : focused.parents("[role=treeitem]");
        var el;
        if (selected.length > 0) {
          el = selected[0];
          return this.findElInTree(el);
        }
      },

      findElInTree: function (el, parent) {
        var parent = parent || this.tree(),
            children = parent.items || parent.groups,
            i,
            treeEl;

        if (parent.el === el) return parent;

        if (!children) return;

        for (i=0; i<children.length; i++) {
          treeEl = this.findElInTree(el, children[i]);
          if (treeEl) return treeEl;
        }
      },

      tree: function () {
        var rootEl = this.$el[0],
        root = {
          el: rootEl
        };

        root.items = this.items(rootEl, root);

        return root;
      },

      items: function (parentEl, parent) {
        var i,
            role,
            el,
            hidden,
            item,
            items = [],
            childItems,
            length = parentEl.childNodes.length;

        for (i=0; i<length; i++) {
          el = parentEl.childNodes[i];
          role = el.getAttribute && el.getAttribute("role");
          hidden = el.getAttribute && el.getAttribute("aria-hidden");

          if (/treeitem/i.test(role) && !(/true/i.test(hidden))) {
            item = {
              el: el,
              parent: parent
            };
            item.groups = this.groups(el, item);
            items.push(item);
          } else if (!/group/i.test(role)) { // don't visit groups as siblings of items
            childItems = this.items(el, parent);
            if (childItems) {
              items = items.concat(childItems);
            }
          }
        }

        return items;
      },

      groups: function (parentEl, parent) {
        var i,
            role,
            el,
            group,
            groups = [],
            childGroups,
            length = parentEl.childNodes.length;

        for (i=0; i<length; i++) {
          el = parentEl.childNodes[i];
          role = el.getAttribute && el.getAttribute("role");

          if (/group/i.test(role)) {
            group = {
              el: el,
              parent: parent
            };
            group.items = this.items(el, group);
            groups.push(group);
          } else if (!/treeitem/i.test(role)) { // don't visit items as siblings of groups
            childGroups = this.groups(el, parent);
            if (childGroups) {
              groups = groups.concat(childGroups);
            }
          }
        }

        return groups;
      },

      select: function (toSelect) {
        if (!toSelect) return;

        var selectTarget = $(toSelect).find(".mb-select-target");
        if (selectTarget.length > 0 && selectTarget.eq(0).parents("[role=treeitem]")[0] === toSelect) {
          toSelect = selectTarget[0];
        }

        this.setTabable(toSelect);
        toSelect.focus();
      },

      selectNext: function () {
        var selected = this.selected(),
            siblings, index, toSelect;

        if (!selected) return this.selectFirst();

        siblings = selected.parent.items;
        index = _.indexOf(siblings, selected);
        toSelect = index + 1;

        if (siblings.length > toSelect) {
          this.select(siblings[toSelect].el);
        }
      },

      selectPrevious: function () {
        var selected = this.selected(),
            siblings, index, toSelect;

        if (!selected) return this.selectFirst();
        
        siblings = selected.parent.items;
        index = _.indexOf(siblings, selected);
        toSelect = index - 1;

        if (toSelect < 0) {
          this.selectParent();
        } else {
          this.select(siblings[toSelect].el);
        }
      },

      selectParent: function () {
        var selected = this.selected();

        if (!selected) return this.selectFirst();

        if (selected && selected.parent.parent) {
          this.select(selected.parent.parent.el);
        }
      },

      selectFirstChild: function () {
        var selected = this.selected(),
            items;

        if (!selected) return this.selectFirst();

        if (selected && selected.groups && selected.groups.length > 0) {
          items = selected.groups[0].items;

          if (items && items.length) this.select(items[0].el);
        }
      },

      selectFirst: function () {
        var tree = this.tree();
        if (tree && tree.items && tree.items.length > 0) {
          this.select(tree.items[0].el);
        }
      },

      selectLast: function () {
        var group = this.tree(),
            lastItem;

        while (group && group.items && group.items.length > 0) {
          lastItem = group.items[group.items.length - 1];
          group = lastItem.groups && lastItem.groups.length > 0 && lastItem.groups[lastItem.groups.length -1];
        }

        if (lastItem) {
          this.select(lastItem.el);
        }
      },

      /* events */
      focusout: function (e) {
        this.$el.attr("tabindex", "0");
      },

      focus: function (e) {
        this.$el.attr("tabindex", "-1");
        var target = e.target;
        if (this.$el.is(target)) {
          target = this.treeitems();
          if (target.size() > 0) target = target[0];
          else target = null;
        }

        if (target) {
          this.setTabable(target);
          this.select(target);
        }
      },

      changeselect: function(e) {
        if (this.selected()) {
          this.selectParent();
        }
      },

      keyUp: function (e) {
        var call;

        if (/(INPUT|TEXTAREA)/i.test(e.target.tagName) && !/checkbox/i.test(e.target.type)) {
// Disabled for DateRangePicker
//          if (e.target.selectionStart !== 0 || e.target.selectionEnd !== 0) {
          if (e.which !== UP && e.which !== DOWN) {
              return true;
          }
        }

        if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) {
          return true;
        }

        switch (e.which) {
          case UP: call = this.selectPrevious; break;
          case DOWN: call = this.selectNext; break;
          case LEFT: call = this.selectParent; break;
          case RIGHT: call = this.selectFirstChild; break;
          case HOME: call = this.selectFirst; break;
          case END: call = this.selectLast; break;
        }

        if (call) {
          call.apply(this, []);
        }
      },

      destroy: function () {
        this.$el.off(".mb-accessibility")
      }

  });

  var AccessibilityContainer = function () {
    this.initialize.apply(this, arguments);
  }
  AccessibilityContainer.prototype = {

    initialize: function ($el) {
      var that = this,
          instances = this.instances = [];

      $el = $($el);
      this.$el = $el;

      this.patchAriaAttributes();

      this.roles = new Role($el, {
        selector: ".mb-role[role]",
        handlers: {
          tablist: tablistHandler,
          dialog: dialogHandler,
          "document": dialogHandler,
          toolbar: toolbarHandler,
          menu: toolbarHandler
        }
      });

      this.tooltips = new TooltipRole($el, {
        selector: ".mb-role[aria-describedby]"
      });

      $el.on("mousedown.mb-accessibility", function (e) {
        that.disableFocusHighlighting();
      });
      $el.on("keydown.mb-accessibility", function (e) {
        if (e.which === keys.tab) {
          that.enableFocusHighlighting();
        }
      });

      $($el).each(function () {
        var tree = $(this).find("[role=tree]");
        tree.each(function () {
          instances.push(new Tree({
            el: this
          }));
        });

        $(this).find("script[type=\"text/x-mustache-template\"]").each(function () {
          this.setAttribute("aria-hidden", "true");
        });
      });
    },

    patchAriaAttributes: function () {
      this.patchAriaAttribute("describedby");
      this.patchAriaAttribute("labelledby");
    },

    patchAriaAttribute: function (attributeName) {
      $("[data-aria-" + attributeName + "]").each(function () {
        this.setAttribute("aria-" + attributeName, this.getAttribute("data-aria-" + attributeName));
      });
    },

    disableFocusHighlighting: function () {
      this.$el.removeClass("mb-highlight-focus");
    },

    enableFocusHighlighting: function () {
      this.$el.addClass("mb-highlight-focus");
    },

    destroy: function () {
      this.$el.off(".mb-accessibility")
      _.each(this.instances, function (instance) {
        instance.destroy();
      });
      this.instances = [];
      this.tooltips.destroy();
      this.roles.destroy();
    }
  };

  return {

    Container: AccessibilityContainer,

    /* High Contrast Mode detection */
    highContrast: {
      DARK: "mb-high-contrast mb-white-on-black",
      LIGHT: "mb-high-contrast mb-black-on-white",

      detect: function () {
        var result;
        this.testHelper(_.bind(function highcontrast_detectDark(elem) {
            elem.style.background = "#fff";
            var color = this.getValues($(elem).css("background-color"));
            if (this.getHex(color) !== "#FFFFFF") {
              result = this.isDark(color) ? this.DARK : this.LIGHT;
            }
        }, this));
        this.testHelper(_.bind(function highcontrast_detectLight(elem) {
            elem.style.background = "#000";
            var color = this.getValues($(elem).css("background-color"));
            if (this.getHex(color) !== "#000000") {
              result = this.isDark(color) ? this.DARK : this.LIGHT;
            }
        }, this));
        return result;
      },

      get: function () {
        var result = this.detect();
        this.get = function () { return result; };
        return result;
      },

      // helpers

      getValues: function (color, invertbyteorder) {
        if (typeof color == "object") {
          if (color.length == 3) {
            return color;
          }
          else if (color.B != "undefined") {
            return [color.R, color.G, color.B];
          }
        }
        else if (typeof color == "string") {
          color = color.toLowerCase();
          if(color[0] == "#") {
            var isshort = (color.length < 7),
                red = parseInt(isshort ? color.substr(1,1) + color.substr(1,1) : color.substr(1,2), 16),
                green = parseInt(isshort ? color.substr(2,1) + color.substr(2,1) : color.substr(3,2), 16),
                blue = parseInt(isshort ? color.substr(3,1) + color.substr(3,1) : color.substr(5,2), 16);
            return [red, green, blue];
          }
          else if (color.indexOf("rgb")>=0) {
            var substrstart = color.indexOf("(") + 1,
                substlength = color.indexOf(")") - substrstart,
                colorsplit;
            color = color.substr(substrstart, substlength);
            colorsplit = color.split(",");
            if (colorsplit.length >= 3) {
              return [parseInt(colorsplit[0]), parseInt(colorsplit[1]), parseInt(colorsplit[2])];
            }
          }
          else if (color == "transparent") {
            return null;
          }
          else {
            return this.getValues(parseInt(color));
          }
        }
        else if (typeof color == "number" && !isNaN(color)) {
          var red, green, blue;
          if (invertbyteorder) {
            blue = color >> 16,
            green = (color & 0x00FF00) >> 8,
            red = (color & 0x0000FF);
          }
          else {
            red = color >> 16,
            green = (color & 0x00FF00) >> 8,
            blue = (color & 0x0000FF);
          }
          return [red, green, blue];
        }
      },

      getHex: function (color, invertbyteorder) {
        if (color = this.getValues(color, invertbyteorder)) {
          var hexstr = "#",
              hexval;
          for (var i = 0; i < 3; i++) {
            hexval = color[i].toString(16);
            hexstr += (hexval.length == 2) ? hexval : "0" + hexval;
          }
          return hexstr.toUpperCase();
        }
      },

      isDark: function vappcolor_isDark(color) {
        return (this.getBrightness(color) < 125);
      },

      getBrightness: function vappcolor_getBrightness(color) {
        if (color = this.getValues(color)) {
          return ((color[0] * 299) + (color[1] * 587) + (color[2] * 114)) / 1000;
        }
      },

      testHelper: function (callback) {
        var elem = this.getHelper(true),
            orgclassname = elem.className,
            result;
        result = callback(elem);
        elem.className = orgclassname;
        return result;
      },

      getHelper: function (getmaxelem) {
        if (getmaxelem) {
          if (!this.maxhelperelem) {
            this.maxhelperelem = document.createElement("DIV");
            document.body.appendChild(this.maxhelperelem);
          }
          return this.maxhelperelem;
        }
        if (!this.helperelem) {
          var tab = document.createElement("TABLE"),
              tbody = document.createElement("TBODY"),
              tr = document.createElement("TR");
          this.helperelem = document.createElement("TD");
          tab.appendChild(tbody);
          tbody.appendChild(tr);
          tr.appendChild(this.helperelem);
          document.body.appendChild(tab);
        }
        return this.helperelem;
      }
    }

  };

});
